import React, { useState } from 'react';
import type { Archetype } from '../../types/investmentPhilosophy';

interface IPTopMatchCardProps {
  archetype: Archetype;
  percentage: number;
}

export const IPTopMatchCard: React.FC<IPTopMatchCardProps> = ({ archetype, percentage }) => {
  const [imgError, setImgError] = useState(false);
  const initials = archetype.name
    .split(' ')
    .map((p) => p[0])
    .join('')
    .slice(0, 2);

  return (
    <div
      className="rounded-2xl p-6 text-center animate-fade-up opacity-0"
      style={{
        backgroundColor: 'var(--clue-bg-card)',
        border: '1px solid var(--clue-border-light)',
        boxShadow: 'var(--clue-shadow-md)',
      }}
    >
      <div className="flex justify-center mb-4">
        {imgError ? (
          <div
            className="w-24 h-24 rounded-2xl flex items-center justify-center font-serif text-3xl"
            style={{
              backgroundColor: 'var(--clue-green-soft)',
              color: 'var(--clue-green-dark)',
            }}
          >
            {initials}
          </div>
        ) : (
          <img
            src={archetype.photoUrl}
            alt={archetype.name}
            onError={() => setImgError(true)}
            className="w-24 h-24 rounded-2xl object-cover"
            style={{ border: '1px solid var(--clue-border-light)' }}
          />
        )}
      </div>

      <p
        className="font-mono text-xs uppercase tracking-wider mb-2"
        style={{ color: 'hsl(var(--muted-foreground))' }}
      >
        Your top match
      </p>

      <div className="flex items-baseline justify-center gap-2 mb-1">
        <span
          className="font-mono text-5xl font-bold"
          style={{ color: 'var(--clue-green-accent)' }}
        >
          {percentage}
        </span>
        <span
          className="font-mono text-xl font-bold"
          style={{ color: 'var(--clue-green-accent)' }}
        >
          %
        </span>
      </div>

      <h2
        className="font-serif text-2xl mb-1"
        style={{ color: 'hsl(var(--foreground))' }}
      >
        {archetype.name}
      </h2>

      <p
        className="font-mono text-xs uppercase tracking-wider mb-4"
        style={{ color: 'var(--clue-green-accent)' }}
      >
        {archetype.descriptor}
      </p>

      <p
        className="text-sm leading-relaxed"
        style={{ color: 'hsl(var(--muted-foreground))' }}
      >
        {archetype.bio}
      </p>
    </div>
  );
};
